
import React, { useState, useEffect } from "react";
import cn from "classnames";
import { Link } from "react-router-dom";
import styles from "./Signin.module.scss";
import AuthService from "services/auth.service";
import LocalStorageService from "services/tokenlocalstorage.service";
import { useHistory, Redirect } from "react-router-dom";
import notificationService from "services/notification.service";
export default function Signin(props) {
  const history = useHistory();
  const handleEmail = (e) => {
    setEmail(e.target.value);
  };

  const [email, setEmail] = useState();
  const [error, setError] = useState();
  const [success, setSuccess] = useState();

  const signin = async () => {
    if (!email) {
      setError("Please Enter Email");
      return;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i.test(email)) {
      setError("Please enter valid email ID");
      return;
    } else {
      setError("");
      // history.push("ResetPassword");
    }

    AuthService.forgotPassword(email).then(
      (response) => {
        if (response.data) {
          setSuccess(
            "Email send successfully, Please check your inbox for further instructions."
          );
          notificationService.showNonBlacklisted(
            response?.config?.url,
            response?.data?.message
          );
        }
        // return response.data;
      },
      (error) => {
        setError(
          error?.data?.message
            ? error.data.message
            : "Failed to send email, Please check your email id"
        );
      }
    );
  };

  return (
    <div
      className={`Signin ${cn(styles.block, styles.block_layout, styles.signin_container)}`}
      style={{
        backgroundImage: `url(${require("assets/loginBackgrnd.png").default})`,
      }}
    >
      <div className={cn(styles.cover_block1, styles.cover_block1_layout)}>
        <div className={cn(styles.flex, styles.flex_layout)}>
          <div className={cn(styles.flex1, styles.flex1_layout)}>
            <div className={cn(styles.flex1_item)}>
              <div
                style={{
                  "--src": `url(${require("assets/jio-logo.png").default})`,
                }}
                className={cn(styles.icon, styles.icon_layout)}
              />
            </div>
            <div className={cn(styles.flex1_spacer)} />
            <h1 className={cn(styles.hero_title, styles.hero_title_layout)}>
              &nbsp;{"SwapUp"}
            </h1>
          </div>

          <h1 className={cn(styles.hero_title1, styles.hero_title1_layout)}>
            {"Forgot Password"}
          </h1>
          <h2 className={cn(styles.medium_title, styles.medium_title_layout)}>
            {"Email*"}
          </h2>
          <input
            type="text"
            name="email"
            className={cn(styles.box1, styles.box1_layout)}
            required
            value={email}
            onChange={handleEmail}
            placeholder={"Please enter your email"}
            color="#8E8E8E"
          />

          <div className={cn(styles.flex2_fg, styles.flex2_fg_layout)}>
            <Link to="/">
              <div className={cn(styles.text_body, styles.text_body_layout)}>
                {"Back to login"}
              </div>
            </Link>
          </div>
          <div className={cn(styles.flex1_spacer)} />
          <div
            className={cn(styles.cover_block, styles.cover_block_layout)}
            onClick={signin}
          >
            <h2
              className={cn(styles.medium_title1, styles.medium_title1_layout)}
            >
              {"Send"}
            </h2>
          </div>
          {error && (
            <p
              style={{
                textAlign: "center",
                marginBottom: "20px",
                color: "red",
              }}
            >
              {error}
            </p>
          )}

          {success && (
            <p
              style={{
                textAlign: "center",
                marginBottom: "20px",
                color: "#23297a",
              }}
            >
              {success}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

Signin.inStorybook = true;
